// @flow

import { searchEndpoint } from './crud-factory'

export async function getHCMSForms(
  formsAppEnvironmentId: number
): Promise<Form[]> {
  const { forms }: { forms: Form[] } = await searchEndpoint('/forms', {
    formsAppEnvironmentId,
  })
  return forms.filter((form) =>
    form.submissionEvents.some(
      (submissionEvent) => submissionEvent.type === 'CP_HCMS'
    )
  )
}
